import { isSupportedCurrency } from '@sentola/money';
import type { SupportedCurrency } from '@sentola/money';

export type StoredCurrencyFields = {
    /** The live field. */
    currency?: string;
    // TODO(T18 cleanup): drop this field and the branch that reads it once no settings doc carries toolsCurrency any more
    toolsCurrency?: string;
};

export type ReportingCurrencyResolution =
    // needsCleanup is only ever true because of toolsCurrency — drop it in the same pass.
    | { code: SupportedCurrency; needsCleanup: boolean }
    | { unsupported: string }
    | { unset: true };

export function resolveReportingCurrency({ currency, toolsCurrency }: StoredCurrencyFields): ReportingCurrencyResolution {
    if (toolsCurrency) {
        return isSupportedCurrency(toolsCurrency)
            ? { code: toolsCurrency, needsCleanup: true }
            : { unsupported: toolsCurrency };
    }

    if (currency) {
        return isSupportedCurrency(currency)
            ? { code: currency, needsCleanup: false }
            : { unsupported: currency };
    }

    return { unset: true };
}
